export default __webpack_public_path__ + "static/mx-bc63d25be57acf721e56aa378395e51b.svg";